import React, { useEffect, useMemo } from 'react'
import { CheckboxSelector, Avatar, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'
import { gql, useLazyQuery } from '@apollo/client'
import FilterBadge from '../../../common/FilterBadge'

const StudentsFilter = (props) => {
  const { translate } = useTranslation()
  const { 
    setUpcommingLesson = () => {}, 
    useInner = false,
  studentFilters, setStudentFilters, loading=false, roles = ['STUDENT'], label = 'Student',
  students: providedStudents, parentUserId, onStudentsLoaded = () => {} } = props


  const [getStudents, { data: dataStudent, loading: loadingStudent, error: errorStudent }] = useLazyQuery(
    gql`query($roles: [Roles!], $search: String, $limit: Int) {
      allUsers(roles: $roles, search: $search, limit: $limit) {
        docs {
          id
          firstName
          lastName
          studentInfo {
            upcomingLesson { id }
            parents { parentUserId }
          }
        }
      }
    }`,
    {
      variables: { limit: 0, roles, search: '' },
      fetchPolicy: 'cache-first'
    }
  )
  
  useEffect(() => {
    if (!Array.isArray(providedStudents)) getStudents()
  }, [getStudents, providedStudents])

  useEffect(() => {
    if (Array.isArray(providedStudents)) {
      onStudentsLoaded({ students: providedStudents, loading: false, error: null })
      return
    }

    onStudentsLoaded({
      students: dataStudent?.allUsers?.docs || [],
      loading: loadingStudent,
      error: errorStudent
    })
  }, [dataStudent, errorStudent, loadingStudent, onStudentsLoaded, providedStudents])
  const students = useMemo(
    () => {
      const allStudents = Array.isArray(providedStudents) ? providedStudents : dataStudent?.allUsers?.docs || []
      if (!parentUserId) return allStudents
      return allStudents.filter((student) => (
        (student?.studentInfo?.parents || []).some(({ parentUserId: relatedParentId }) => relatedParentId === parentUserId)
      ))
    }, [dataStudent, providedStudents, parentUserId]
  )  

  const studentOptions = students.map(user => ({
    name: `${user.firstName} ${user.lastName}`,
    id: user.id,
    Component: (
      <Avatar
        name={`${user.firstName} ${user.lastName}`}
        named={false}
        uri={null}
        size='avatar-small'
      />
    )
  })).sort((a, b) => a.name.localeCompare(b.name))

  const checkboxSelectorProps = {
    setDataFilters: (idUser) => {
      const upcommings = students.filter(({id}) => idUser.includes(id) ).reduce((newArray, user) => {
        if(user?.studentInfo?.upcomingLesson?.id) newArray.push(user.studentInfo.upcomingLesson.id)
        return newArray
      }, [])
      setUpcommingLesson(upcommings)
      setStudentFilters(idUser)
    },
    direction: 'bottomLeft',
    dataFilters: studentFilters,
    loading: loading || (!Array.isArray(providedStudents) && loadingStudent),
    data: studentOptions,
    typeFilter: 'users',
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return (
    useInner ?
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps} /> :
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title={label || translate('filters.plans.studentsTitle')}
        options={studentOptions}
        selectedIds={studentFilters}
        onClearFilters={() => setStudentFilters([])}
      />
    </CheckboxSelector>
  )
}
export default StudentsFilter
